<template>
  <div class="f_content">
    <div class="Employees-Add-New-Employee">
      <router-link to="/employee">Employees ></router-link>
      <a>New Employee</a>
    </div>
    <div class="Onboard-New-Employee">
      <div class="Onboard-New-Employee__name">Onboard Multiple Employees</div>
      <div class="Onboard-New-Employee__btn" @click="onboardWithCsv()">
        +Upload Template
      </div>
    </div>
    <img
      class="img-fluid rounded d-block user"
      src="./../../../assets/style/images/user.svg"
      alt="user added"
    />
    <p class="adduser">Let's Bring Your Employees Onboard</p>
    <form
      class="needs-validation multiple-entry-form"
    >
      <p class="text-primary">Enter Their Details Here:</p>
      <div
        class="form-input"
        v-for="(employee, index) in employees"
        :key="index"
      >
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            id="inputFirstname"
            placeholder="First Name"
            v-model="employee.firstname"
            required
          />
        </div>
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            id="inputLastname"
            placeholder="Last Name"
            v-model="employee.lastname"
            requnred
          />
        </div>
        <div class="form-group">
          <input
            type="email"
            class="form-control"
            id="inputemail"
            placeholder="Email Address"
            v-model="employee.email"
            required
          />
        </div>
        <div class="form-group">
          <input
            type="tel"
            class="form-control"
            id="inputNumber"
            placeholder="Phone Number"
            v-model="employee.phone"
            required
          />
        </div>
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            id="inputID"
            placeholder="Staff number"
            v-model="employee.staff_number"
            required
          />
        </div>

        <span
          class="text-danger"
          v-if="index !== 0"
          @click.prevent="removeForm(index)"
          >x</span
        >
      </div>

      <button
        type="button"
        name
        id
        @click="addForm"
        class="btn btn-outline-secondary btn-lg btn-block addmore"
      >
        + Add more Employees
      </button>

      <div class="error">
        <p v-if="formError">All the form fields are required.</p>
        <p v-if="emailError">Email is not a valid email.</p>
        <p v-if="phoneError">Phone number must be digits.</p>
        <div v-if="serverErrors">{{ serverErrors }}</div>
        <div v-if="userError">
          <p v-for="(userErr, index) in userErrMsg" :key="index">
            {{ userErr }}
          </p>
        </div>
      </div>

      <div class="text-center endbutton mt-5">
        <button
          type="submit"
          class="btn btn-primary savebutton mr-4"
          @click.prevent="saveAndContinue()"
          v-if="!savingEmployees"
        >
          Save & Continue
        </button>
        <div v-else>
          <BlueLoader />
        </div>
        <button
          type="button"
          class="btn btn-outline-secondary px-3"
          @click.prevent="cancelForm()"
        >
          Cancel
        </button>
      </div>
    </form>
    <div class="multiplemodal" v-if="modal">
      <div>
        <div>
          <p>
            <span @click="closeCsv">
              <font-awesome-icon icon="times" />
            </span>
          </p>
          <div>
            <div class="multiplemodal__image">
              <img src="./../../../assets/images/csv.png" alt />
            </div>
            <span>Upload Employee Template</span>
            <p>
              Instead of filling out each employee's detail by hand, upload the
              updated template and hrdesk will be magically fill it out. To get
              started,
              <span>
                <a :href="templateUrl" download>download our template</a>
              </span>
              and open it with your favorite spreadsheet software.
            </p>
            <div class="multiplemodal__upload">
              <div v-show="!uploadedFile">
                <img src="./../../../assets/images/uploadcsv.png" alt />
              </div>
              <span v-show="!uploadedFile">Select File</span>
              <p v-show="!uploadedFile">or drop your file here</p>
              <p v-show="uploadedFile">{{ uploadedFileName }}</p>
              <input type="file" accept=".xls,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ref="csv" @change="uploadCsv" />
            </div>
            <div class="multiplemodal__err">
              <span v-if="noFile"
                >Please uplaod a template file with extensions " .csv, .xls,
                .xlsx".</span
              >
              <span v-if="fileSize">File must be less than 1 Gig.</span>
              <span v-if="respMsg">{{ respMsg }}</span>
              <span v-if="networkErr"
                >Network error. Please try again later.</span
              >
            </div>
            <div class="multiplemodal__btns">
              <div
                class="multiplemodal__btns--upload"
                v-if="!btnLoader"
                @click="sendCsv"
              >
                Upload
              </div>
              <div class="multiplemodal__btns--upload" v-if="btnLoader">
                <WhiteLoader />
              </div>
              <div class="multiplemodal__btns--cancel" @click="closeCsv">
                Cancel
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import BlueLoader from "../../partials/blue-loader";
import WhiteLoader from "../../partials/white-loader";

export default {
  name: "multipleEmployee",

  components: {
    BlueLoader,
    WhiteLoader,
  },

  data() {
    return {
      templateUrl: '',
      employees: [
        {
          email: "",
          lastname: "",
          firstname: "",
          phone: "",
          staff_number: "",
        },
      ],

      savingEmployees: false,
      formError: false,
      emailError: false,
      phoneError: false,
      userError: false,
      userErrMsg: [],
      serverErrors: null,
      modal: false,
      uploadedFile: false,
      file: "",
      fileName: "",
      uploadedFileName: "",
      fileExt: "",
      noFile: false,
      fileSize: false,
      btnLoader: false,
      respMsg: null,
      respCheck: false,
      networkErr: false,
    };
  },
  methods: {
    uploadCsv() {
      this.uploadedFile = false;
      this.noFile = false;
      this.fileSize = false;
      this.respCheck = false;
      this.networkErr = false;
      this.fileName = this.$refs.csv;
      this.file = this.$refs.csv.files[0];
      this.fileExt = this.fileName.value.split(".").pop();

      if (this.file) {
        this.uploadedFileName = this.fileName.value.split("\\").pop();
        this.uploadedFile = true;
      }
    },
    sendCsv() {
      this.respMsg = null;

      if (!this.fileExt) {
        this.noFile = true;
        return;
      }

      if (
        this.fileExt.toLowerCase().trim() === "csv" ||
        this.fileExt.toLowerCase().trim() === "xls" ||
        this.fileExt.toLowerCase().trim() === "xlsx"
      ) {
    
        if (this.file.size > 1073741824) {
          this.fileSize = true;
          return;
        }
        this.btnLoader = true;
        let formData = new FormData();
        formData.append("file", this.file);

        this.$http
          .post(types.POST_EMPLOYEES_CSV, formData)
          .then((resp) => {
            this.btnLoader = false;
            this.respMsg = resp.data.message;
            if (resp.data.data.errors.length > 0) {
              for (let index of resp.data.data.errors) {
                this.respMsg =
                  this.respMsg +
                  " For User with email " +
                  index.employee.email +
                  " -> ";
                let demo = "";
                for (let num in index.error) {
                  demo = demo + index.error[num];
                }
                this.respMsg = this.respMsg + demo;
              }
              return;
            }

            this.$router.push("/employee");
          })
          .catch((err) => {
            this.btnLoader = false;
            this.respMsg = err.response.message
          });
        return;
      }
      this.noFile = true;
      return;
    },
    addForm() {
      this.formError = false;
      this.employees.push({
        email: "",
        lastname: "",
        firstname: "",
        phone: "",
        staff_number: "",
      });
    },

    removeForm(index) {
      if (this.employees.length > 1) {
        this.formError = false;
        this.employees.splice(index, 1);
      }
    },

    saveAndContinue() {
      this.savingEmployees = false;
      this.formError = false;
      this.serverErrors = null;
      this.userError = false;
      this.emailError = false;
      this.phoneError = false;

      if (!this.validate()) {
        this.formError = true;
        return;
      }

      const expression = /\S+@\S+\.\S+/;
      for (let index of this.employees) {
        if (!expression.test(index.email.trim())) {
          this.emailError = true;
          return;
        }

        if (isNaN(index.phone)) {
          this.phoneError = true;
          return;
        }
      }

      const employees = {
        employees: this.employees,
      };

      this.savingEmployees = true;
      this.$http
        .post(types.ONBOARD_MULTIPLE_EMPLOYEES, employees)
        .then((resp) => {
          this.$router.push("/employee");
        })
        .catch((err) => {
          this.savingEmployees = false;
          this.serverErrors = err.response.data.message;
        });
    },

    validate() {
      let flag = true;

      this.employees.forEach((newEmployee) => {
        for (var key in newEmployee) {
          const value = newEmployee[key].trim();

          if (!value) {
            flag = false;
          }
        }
      });

      return flag;
    },

    onboardWithCsv() {
      this.btnLoader = false;
      this.modal = true;
    },

    closeCsv() {
      this.modal = false;
    },

    cancelForm() {
      this.formError = false;
      this.userError = false;
      this.employees = [
        {
          email: "",
          lastname: "",
          firstname: "",
          phone: "",
          staff_number: "",
        },
      ];
    },
  },
    mounted() {
    this.templateUrl =
      types.STATIC_STAFF_TEMPLATE;
  },
};
</script>

<style lang="scss" scoped>
$padding-left-large: 60px;
$padding-right-large: 60px;
$padding-left-medium: 30px;
$padding-right-medium: 30px;
$padding-left-small: 10px;
$padding-right-small: 10px;

.f_content {
  padding-top: 35px;
  padding-left: $padding-left-large;
  padding-right: $padding-right-large;

  @media (max-width: 768px) {
         padding: 2rem;
        }
  input,
  input:focus {
    outline: none;
  }
  .form-control {
    box-shadow: none !important;
    border: solid 1px #c7c7c7;
    background-color: #ffffff;
  }

  .error {
    margin-top: 10px;
    color: red;
    font-size: 0.938rem;
    font-style: italic;
    p {
      padding-top: 20px;
      margin-bottom: 0;
      text-align: center;
    }
    p::first-letter {
      text-transform: uppercase;
    }
    > div {
      padding-bottom: 10px;
    }
  }

  .uploadCV {
    width: 150px;
    height: 33px;
    border-radius: 2px;
    background-color: #5099de;
    font-family: Nunito;
    font-size: 0.729rem;
    margin-top: -7px;
    cursor: pointer;
    color: #fff;
  }

  .user {
    width: 100px;
    height: 101.4px;
    height: auto;
    object-fit: contain;
    margin-left: auto;
    margin-right: auto;
    margin-top: 40px;
  }

  .user + p {
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    margin-top: 40px;
  }

  .Employees-Add-New-Employee {
    width: 348px;
    height: 50px;
    font-family: Nunito;
    font-size: 1rem;
    font-weight: 200;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.67;
    letter-spacing: normal;
    text-align: left;
    color: #707070;
    text-decoration: none;
    a:first-child {
      color: #5099de;
    }
  }
  .Onboard-New-Employee {
    font-size: 1.198rem;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
    display: flex;
    border-bottom: 2px solid #ebe4e4;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    align-content: center;
    padding-bottom: 5px;

    > .Onboard-New-Employee__name {
      width: 300px;
      font-size: 1.198rem;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      letter-spacing: normal;
      text-align: left;
      color: #000000;
    }

    > .Onboard-New-Employee__btn {
      width: 200px;
      font-size: 1rem;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      padding: 12px 0;
      border-radius: 2px;
      background-color: #5099de;
      color: #fff;
      text-align: center;
      cursor: pointer;
    }
  }
  .onboard {
    width: 300px;
    height: 33px;
    border-radius: 2px;
    background-color: #5099de;
    font-family: Nunito;
    font-size: 0.729rem;
    margin-top: -7px;
  }
}

.multiple-entry-form {
  max-width: 60rem;
  margin: 0 auto 10rem auto;
  box-shadow: 0 5px 6px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding: 2.5rem;
  .addmore {
    width: 95%;
    border: dotted 2px #dddcdc;
    background-color: #ffffff;
    font-family: Nunito;
    font-size: 0.885rem;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 2;
    letter-spacing: normal;
    color: #777777;
    margin: 1rem;
    @media (max-width: 768px) {
      width: 100%;
      margin: 0;
    }
  }
  .text-primary {
    color: #5099de !important;
  }
  .endbutton {
    display: flex;

    @media (max-width:768px) {
      flex-direction: column;
    }
    .savebutton {
      background-color: #5099de;
      @media (max-width:768px) {
      margin-bottom: 1rem;
    }
    }
  }

  .form-input {
    display: flex;

    @media (max-width: 768px) {
          flex-direction: column;
        }
    .form-row {
      height: 75px;
    }
    .form-group {
      display: flex;
      justify-content: center;
      input {
        width: 140px;

        @media (max-width: 768px) {
          width: 12rem;
        }
      }
    }
    ::placeholder {
      color: #777777;
      opacity: 0.5;
      font-size: 0.729rem;
    }
    span {
      width: 2px;
      padding: 5px 0px 0px 2px;
      cursor: pointer;
    }
  }
}

.multiplemodal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  overflow: auto;
  z-index: 9999999;

  > div {
    max-width: 800px;
    padding: 0 10px;
    margin: 50px auto;

    > div {
      background: #fff;
      padding: 20px;
      border-radius: 4px;

      > p {
        text-align: right;

        > span {
          cursor: pointer;
        }
      }

      > div {
        margin-top: 20px;
        text-align: center;
        padding-left: 50px;
        padding-right: 50px;

        > .multiplemodal__image {
          width: 50px;
          height: 50px;
          margin: 0 auto 20px auto;
        }

        > span {
          font-size: 1.5rem;
          font-weight: 500;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.43;
          letter-spacing: normal;
          text-align: center;
          color: #000000;
        }

        > p {
          font-size: 1.5rem;
          font-weight: 200;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.46;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
          margin-top: 30px;

          > span {
            font-weight: normal;
            color: #5099de;
          }
        }

        > .multiplemodal__upload {
          width: 300px;
          padding: 0 20px;
          border: dashed 1px #5099de;
          margin: 10px auto;
          position: relative;

          > input {
            position: absolute;
            top: 0;
            left: 0;
            background-color: red;
            width: 100%;
            height: 100%;
            opacity: 0;
            cursor: pointer;
          }

          > div {
            width: 40px;
            margin: 20px auto;

            > img {
              width: 100%;
            }
          }

          > span {
            font-size: 1rem;
            font-weight: 200;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.67;
            letter-spacing: normal;
            text-align: center;
            color: #5099de;
          }

          > p {
            font-size: 1rem;
            font-weight: 200;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.67;
            letter-spacing: normal;
            text-align: center;
            color: #000000;
          }
        }

        > .multiplemodal__err {
          font-size: 1rem;
          color: red;
          font-style: italic;
          text-align: center;
        }

        > .multiplemodal__btns {
          width: 300px;
          margin: 20px auto;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: space-between;
          align-content: center;

          > .multiplemodal__btns--upload {
            width: 45%;
            height: 40px;
            border-radius: 5px;
            background-color: #5099de;
            font-size: 1rem;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.2;
            letter-spacing: normal;
            text-align: center;
            color: #ffffff;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
            cursor: pointer;
          }

          > .multiplemodal__btns--cancel {
            width: 45%;
            height: 40px;
            border-radius: 5px;
            background-color: #dcdcdc;
            font-size: 1rem;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.2;
            letter-spacing: normal;
            text-align: center;
            color: #000000;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
